import { AddressProducts } from '../address/address.model';
import { ILSystem } from '../integrationlayer/api.model';

export interface Account {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  impersonator?: string;
  salutation?: string;
}

export interface IConfirmationStatus {
  isLoggedIn: boolean;
  hasAccount: boolean;
  isPartner: boolean;
}

export interface IMigrationResult {
  migrationResultStatus: string;
  email: string;
  keycloakId: string;
  actionToken: string;
}

export interface IPersonalInfoModel {
  firstName: string;
  lastName: string;
}

export interface AccountSelectedEvent {
  addressProducts: AddressProducts;
  systemId: ILSystem;
  accountId: string;
}

export enum AccountInfoStatus {
  NO_ACCOUNT = 0,
  HAS_ACCOUNT = 1,
  IS_PARTNER = 2,
  CREATE_ERROR = 3,
}
